/* eslint-disable no-undef */
import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ROUTES as _routes } from '../../constants/app-constants';
// import { getFeedback } from '../../burger-king-lib/redux/cart/actions';
// import { getFeedbackPayload } from '../../payload-handling/cart';
import FeedbackImage from '../../../assets/images/bkLogo.png';
// import FeedbackOrderDetaill from '../order-detail-feedback/new';
// import AccountSubSecTitle from '../../components/accout-subsec-title';
import './index.scss';
// import RatingsButton from '../../components/ratings-button';
import OffersToast from '../../components/offers-toast';
// import Input from '../../components/input';
import Button from '../../components/button';
import AppleStoreImage from '../../../assets/images/app-store.png';
import GooglePlayStoreImage from '../../../assets/images/google-play-store.png';

// import Rate from '../../components/rate';
// import SliderComponent from '../../components/range-slider';

class FeedbackK extends React.Component {
  constructor() {
    super();
    this.state = {
      // user_id: SessionStorage.get(LocalSessionKey.USER_ID),
      // remarks: '',
      // rating: null,
      // ratings: null,
      // quantity: '',
      // hygiene: '',
      // ambience: '',
      // freshness: '',
      // taste: '',
      // temperature: '',
      // app: null,
      // ease: '',
      // speed: '',
      // payment: '',
      // is_right: false,
      // active: false,
      isMobileView: this.isMobileView(),
      dataFeed: {},
      address: {},
      id: '',
      toastMessage: '',
      type: ''
      // range: 0
    };
  }

  componentDidMount = () => {
    let { dataFeed, address, id, type } = this.state;
    const { location } = this.props;
    const { state } = location;
    if (state) {
      dataFeed = state.order;
      address = dataFeed.address;
      id = state.id;
      type = dataFeed.cart_added_for;
      this.setState({ dataFeed, address, id, type });
    } else {
      const { data, orderID } = this.props;
      dataFeed = data;
      // address = data.address;

      id = orderID;
      // type = dataFeed.cart_added_for;
      this.setState({ dataFeed, address, id, type });
    }
  };

  // componentDidUpdate(prevProps) {
  //   const { feedbackData } = this.props;
  //   if (
  //     feedbackData &&
  //     feedbackData.feedback &&
  //     feedbackData.feedback !== prevProps.feedbackData.feedback
  //   ) {
  //     if (feedbackData.feedback.content && feedbackData.feedback.error === 0) {
  //       alert(feedbackData.feedback.content);
  //       this.onToastMsg();
  //     }
  //     if (feedbackData.feedback.error === 1)
  //       alert(feedbackData.feedback.message);
  //   }
  // }

  onChangeRatingButton = (id, value) => {
    this.setState({ [id]: value });
  };

  onCloseHandler = () => {
    const { onCloseHandler } = this.props;
    onCloseHandler();
  };

  // handleChange = (Id, val, e) => {
  //   const { target } = e;
  //   const { value } = target;
  //   this.setState({ remarks: value, active: true });
  // };

  onChangeRating = (id, value) => {
    this.setState({ [id]: value });
  };

  isMobileView = () => {
    if (window.innerWidth > 1023) {
      return false;
    }
    return true;
  };

  rightContentClickHandler = () => {
    const { history } = this.props;
    history.push(_routes.HELP_SUPPORT);
  };

  DownloadClicked = () => {
    window.open('https://burgerkingindia.page.link/gNpB');
  };

  render() {
    const { toastMessage, isMobileView } = this.state;
    const theme = window.sessionStorage.getItem('theme');
    const { close } = this.props;
    const Dom = (
      <>
        <div className={`feedback-form ${theme}`}>
          {isMobileView && (
            <div
              className="act-sub-sec__mob"
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              {/* <div className="act-sub-sec__left"> */}
              <div className="act-sub-sec__title">
                Welcome to BurgerKing india
              </div>
              {/* </div> */}
            </div>
          )}
          <div className="feedback-form_fullContent">
            <div className="feedback-form_headerNew new-class">
              <img
                src={FeedbackImage}
                alt="burger"
                className="feedback-form__image1 theme"
              />
              <p className="feedback-form__title1">
                Hello Guest !!
                <br />
                Don&apos;t Have App yet
              </p>
            </div>

            <div className="feedback-form__submit custom-css1">
              <Button
                theme={theme}
                content="Download the App Now"
                className="feedback-form__submit-btn1"
                onClick={() => this.DownloadClicked()}
              />
            </div>
            {toastMessage ? (
              <OffersToast
                content={toastMessage}
                destroyHanlder={this.toastDestroyHandler}
              />
            ) : (
              ''
            )}

            <div className="feedback-form__title2">
              {' '}
              <a
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  marginLeft: '8px',
                  color: '#512314',
                  fontSize: '1.5rem',
                  textDecoration: 'underline',
                  cursor: 'pointer'
                }}
                onClick={() => close(false)}
              >
                Continue with browser
              </a>
            </div>
            <div
              className="footer__section"
              style={{
                margin: '3rem'
              }}
            >
              {/* <div className="footer__section-title">Download our app</div> */}
              <ul className="footer__list u_display_flexx">
                <li className="footer__list-item u_cursor_pointer">
                  <a
                    href="https://apps.apple.com/us/app/burger-king-india/id1516627543"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={AppleStoreImage}
                      alt="Apple store"
                      width="128"
                      height="38"
                      // onClick={this.imgOnClickHandler}
                      role="presentation"
                    />
                  </a>
                </li>
                <li className="u_cursor_pointer">
                  <a
                    href="https://play.google.com/store/apps/details?id=in.burgerking.android"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {' '}
                    <img
                      src={GooglePlayStoreImage}
                      alt="play store"
                      width="128"
                      height="38"
                      role="presentation"
                    />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </>
    );
    return Dom;
  }
}

const mapStateToProps = state => {
  return {
    feedbackData: state.feedback
  };
};

const mapDispatchToProps = dispatch => {
  return {
    // getFeedbackApiData: payloadData => dispatch(getFeedback(payloadData))
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(FeedbackK)
);
